<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link">
        <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      </div>
      <div v-else key="expand" class="sidebar-logo-link">
        <p class="sidebar-title">{{ title }} </p>
        <hamburger v-if="logo" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      </div>
    </transition>
  </div>
</template>

<script>
  import Hamburger from '@/components/Hamburger'
  import { mapGetters } from 'vuex'
  export default {
    name: 'SidebarLogo',
    components: {
      Hamburger
    },
    props: {
      collapse: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapGetters([
        'sidebar',
      ])
    },
    data() {
      return {
        title: '全部收起',
        logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
      }
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar')
        this.$root.eventHub.$emit('toggleSideBar')
      }
    }
  }

</script>

<style lang="scss" scoped>
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: right;
    cursor: pointer;
    transition: background .3s;
    padding: 4px 15px !important;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: #fff;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    text-align: left;
    padding-left: 24px;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #666;
      line-height: 46px;
      font-size: 15px;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
